import { createFileRoute, useRouter } from "@tanstack/react-router";
import { CheckCircle2Icon } from "lucide-react";
import ContainerInset from "@/components/container-inset";
import PageLayoutRoot, {
  PageLayoutContent,
  PageLayoutHeader,
  PageLayoutQuickInfo,
} from "@/components/page-layout.tsx";
import ProductForm from "@/app/(authenticated)/$merchantId/products/_component/product-form.tsx";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/products/add/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { merchantId } = Route.useParams();
  const router = useRouter();

  return (
    <ContainerInset
      breadcrumbs={[
        {
          title: "Products",
          href: `/${merchantId}/products`,
        },
        {
          title: "New",
          href: "#",
        },
      ]}
    >
      <PageLayoutRoot>
        <PageLayoutHeader
          title="Create product"
          description="Create a reusable template for products"
        />
        <PageLayoutContent>
          <ProductForm
            onCreateSuccess={() => {
              router.history.back();
            }}
          />
        </PageLayoutContent>
      </PageLayoutRoot>
    </ContainerInset>
  );
}
